import { WordCloudLoopComponent } from '../charts/word-cloud-loop-component'

export class AFCompareWordCloud extends WordCloudLoopComponent {
 static config = {
  selector: 'afCompareWordCloud',
  controller: AFCompareWordCloud,
  bindings: WordCloudLoopComponent.config.bindings,
  template: WordCloudLoopComponent.config.template,
 }

 setProperties() {
  this.seriesColors = this.colorUtils.compareMetaColors(this.visualizationMetaData)
 }
}
